// Configuration for backend URL.
//
// Resolution order at runtime:
//   1. If we're on a custom domain (isisp.eu, app.example.com, …) — i.e. the
//      browser hostname is not an Emergent-hosted preview/staging domain and
//      not localhost — always call the same-origin `/api`. This guarantees
//      the frontend talks to whatever backend is currently deployed behind
//      the custom domain, even if an older `REACT_APP_BACKEND_URL` was baked
//      into the bundle by a previous deploy pipeline.
//   2. Otherwise (preview, local dev, Emergent-hosted URLs) use the
//      REACT_APP_BACKEND_URL set at build time, falling back to same-origin.
function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === 'undefined' || !window.location) {
    return envUrl || '';
  }
  const host = window.location.hostname;
  const isEmergentHost = host.includes('emergent') || host.includes('emergentagent');
  const isLocal = host === 'localhost' || host === '127.0.0.1' || host.startsWith('192.168.') || host.endsWith('.local');
  if (!isEmergentHost && !isLocal) {
    // Custom production domain — always same-origin.
    return window.location.origin;
  }
  return envUrl || window.location.origin;
}

export const BACKEND_URL = resolveBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;
